import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import TasksManagement from "layouts/tasks_management";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import UserAdd from "layouts/user/UserAdd";
import UserList from "layouts/user/UserList";
import UserProfile from "layouts/user/UserProfile";

// @mui icons
import Icon from "@mui/material/Icon";
import GreenSchoolAdd from "layouts/green_school/add";
import { Visibility } from "@mui/icons-material";
import { TrackChanges } from "@mui/icons-material";

import GreenSchoolList from "layouts/green_school/list";
import LeaveRequest from "layouts/leave_management/leave_request";
import LeaveList from "layouts/leave_management/LeaveList";
import Attendance from "layouts/attendance/attendance";
import AttendanceList from "layouts/attendance/attendanceList";
import AttendanceDetailsPage from "layouts/attendance/AttendanceDetailsPage";
import Logout from "layouts/logout/logout";
import ForgotPassword from "layouts/authentication/sign-in/forgotPassword";
import TicketAdd from "layouts/ticketingsystem/TicketAdd";
import TicketList from "layouts/ticketingsystem/TicketList";
import TicketEdit from "layouts/ticketingsystem/TicketEdit";
import LeaveActionDialog from "layouts/leave_management/LeaveActionDialog";
// import MissionAdd from "layouts/mission_builder/MissionManagementAdd";
// import ActivitiesManagement from "layouts/mission_activities/Activities";
import FormBuilder from "layouts/form_builder/form_builder";
import Report from "layouts/report/Report";
import FillForm from "layouts/form_builder/FillForm";
import EditForm from "layouts/form_builder/EditForm";
import SendOtp from "layouts/authentication/sign-in/sendOtp";
import VerifyOtp from "layouts/authentication/sign-in/verifyOtp";
import WeeklyReport from "layouts/report/WeeklyReport";
import SubmissionResults from "layouts/form_builder/SubmissionResults";
import BroadcastEmail from "layouts/broadcast/BroadcastEmail";

import WeeklyReportIndex from "layouts/report/WeeklyReportIndex";
import LessonsList from "layouts/lessons/LessonsList";
import LessonsAdd from "layouts/lessons/LessonsAdd";
import LessonsDetails from "layouts/lessons/LessonsDetails";
import ClaimsList from "layouts/claims/ClaimsList";
import ClaimsDetails from "layouts/claims/ClaimsDetails";
import ClaimsAdd from "layouts/claims/ClaimsAdd";
import EventsList from "layouts/events/EventsList";
import EventsAdd from "layouts/events/EventsAdd";
import HolidayAdd from "layouts/holidays/HolidayAdd";
import PublicationsList from "layouts/publications/PublicationsList";
import PublicationsAdd from "layouts/publications/PublicationsAdd";
import PhaseManage from "layouts/green_school/PhaseManage";
import WorkPlanList from "layouts/work_plan/WorkPlanList";
import WorkPlanAdd from "layouts/work_plan/WorkPlanAdd";

import MissionTracker from "layouts/mission_tracker";
import UserMission from "layouts/user_mission";
import UserDashboard from "layouts/user-dashboard";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    protected: true,
    showInMenu: true,
    role: [1, 2],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "user-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/user-dashboard",
    component: <UserDashboard />,
    protected: true,
    showInMenu: true,
    role: [3],
  },

  // Management Collapse
  {
    type: "collapse",
    name: "Management",
    key: "management-group",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
    collapse: [
      {
        type: "collapse",
        name: "User Management",
        key: "user/user-list",
        icon: <Icon fontSize="small">person</Icon>,
        route: "/user-list",
        component: <UserList />,
        showInMenu: true,
        role: [1, 2],
      },
      {
        type: "collapse",
        name: "Leave Management",
        key: "leave-request/list",
        icon: <Icon fontSize="small">event_busy</Icon>,
        route: "/leave-list",
        component: <LeaveList />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
      {
        type: "collapse",
        name: "Attendance Management",
        key: "attendance-list",
        icon: <Icon fontSize="small">calendar_month</Icon>,
        route: "/attendance-list",
        component: <AttendanceList />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
      {
        type: "collapse",
        name: "Holiday Management",
        key: "holidays",
        icon: <Icon fontSize="small">event_busy</Icon>,
        route: "/holidays",
        component: <HolidayAdd />,
        protected: true,
        showInMenu: true,
        role: [1],
      },
    ],
  },

  {
    type: "collapse",
    name: "Support Management",
    key: "tickets-list",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/tickets-list",
    component: <TicketList />,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
  },

  // Reports Collapse
  {
    type: "collapse",
    name: "Reports",
    key: "reports-group",
    icon: <Icon fontSize="small">assessment</Icon>,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
    collapse: [
      {
        type: "collapse",
        name: "Weekly Report",
        key: "weekly-report",
        icon: <Icon fontSize="small">cloud_upload</Icon>,
        route: "/weekly-report",
        component: <WeeklyReportIndex />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
      {
        type: "collapse",
        name: "Mission Tracker",
        key: "mission-tracker",
        icon: <Icon fontSize="small">track_changes</Icon>,
        route: "/mission-tracker",
        component: <MissionTracker />,
        protected: true,
        showInMenu: true,
        role: [1, 2],
      },
      {
        type: "collapse",
        name: "My Mission",
        key: "user-mission",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/user-mission",
        component: <UserMission />,
        protected: true,
        showInMenu: true,
        role: [2, 3],
      },
      {
        type: "collapse",
        name: "Claims",
        key: "claims-list",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/claims/list",
        component: <ClaimsList />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
      {
        type: "collapse",
        name: "Green School",
        key: "green-school",
        icon: <Icon fontSize="small">school</Icon>,
        route: "/green-school",
        component: <GreenSchoolList />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
    ],
  },

  {
    type: "collapse",
    name: "Create Tasks",
    key: "form-builder",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/form-builder",
    component: <FormBuilder />,
    protected: true,
    showInMenu: true,
    role: [1],
  },
  {
    type: "collapse",
    name: "Tasks Management",
    key: "tasks-management",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/tasks-management",
    component: <FormBuilder />,
    protected: true,
    showInMenu: true,
    role: [3],
  },

  {
    type: "collapse",
    name: "Broadcast Email",
    key: "broadcast-email",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/broadcast-email",
    component: <BroadcastEmail />,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
  },

  {
    type: "collapse",
    name: "Events",
    key: "events-list",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/events/list",
    component: <EventsList />,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
  },
  // Resource Hub Collapse
  {
    type: "collapse",
    name: "Lessons & Publications",
    key: "resource-hub-group",
    icon: <Icon fontSize="small">auto_stories</Icon>,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
    collapse: [
      {
        type: "collapse",
        name: "Lessons from the field",
        key: "lessons-list",
        icon: <Icon fontSize="small">article</Icon>,
        route: "/lessons/list",
        component: <LessonsList />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
      {
        type: "collapse",
        name: "Publications",
        key: "publications-list",
        icon: <Icon fontSize="small">library_books</Icon>,
        route: "/publications/list",
        component: <PublicationsList />,
        protected: true,
        showInMenu: true,
        role: [1, 2, 3],
      },
    ],
  },

  {
    type: "collapse",
    name: "Work Plan",
    key: "work-plan-list",
    icon: <Icon fontSize="small">event_note</Icon>,
    route: "/work-plan/list",
    component: <WorkPlanList />,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
  },

  // Hidden/Protected routes (no showInMenu)
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Attendance",
    key: "attendance",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/attendance",
    component: <Attendance />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Green School Add",
    key: "green-school/add",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/green-school/add",
    component: <GreenSchoolAdd />,
    protected: true,
    showInMenu: false,
  },
  {
    type: "collapse",
    name: "Leave Request",
    key: "leave-request/add",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/leave-request/add",
    component: <LeaveRequest />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Claims Details",
    key: "claims-details",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/claims/list/:user_id",
    component: <ClaimsDetails />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Add Claim",
    key: "claims-add",
    icon: <Icon fontSize="small">post_add</Icon>,
    route: "/claims/add",
    component: <ClaimsAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Edit Claim",
    key: "claims-edit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/claims/edit/:claim_id/:user_id",
    component: <ClaimsAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Leave Edit",
    key: "leave-request/edit",
    icon: <Icon fontSize="small">event_busy</Icon>,
    route: "/leave-list/:id",
    component: <LeaveList />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    protected: false,
    showInMenu: false,
  },
  {
    type: "collapse",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/forgot-password",
    component: <ForgotPassword />,
    protected: false,
    showInMenu: false,
  },
  {
    type: "collapse",
    name: "Send OTP",
    key: "send-otp",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/send-otp",
    component: <SendOtp />,
    protected: false,
    showInMenu: false,
  },
  {
    type: "collapse",
    name: "Verify OTP",
    key: "verify-otp",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/verify-otp",
    component: <VerifyOtp />,
    protected: false,
    showInMenu: false,
  },
  {
    type: "collapse",
    name: "Add User",
    key: "user/add-user",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/user/add-user",
    component: <UserAdd />,
    showInMenu: false,
  },
  {
    type: "",
    name: "User Edit",
    key: "user-edit",
    route: "/user-edit/:id",
    component: <UserAdd />,
    protected: true,
  },
  {
    type: "",
    name: "Attendance Details",
    key: "attendance-details",
    route: "/attendance-details",
    component: <AttendanceDetailsPage />,
    protected: true,
  },
  {
    type: "",
    name: "Green School Edit",
    key: "green-school/edit",
    route: "/green-school/add/:id",
    component: <GreenSchoolAdd />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Manage Phase",
    key: "green-school/phase-manage",
    icon: <Icon fontSize="small">layers</Icon>,
    route: "/green-school/phase-manage",
    component: <PhaseManage />,
    protected: true,
    showInMenu: false,
    role: [1, 2],
  },
  {
    type: "collapse",
    name: "Ticketing System",
    key: "ticketing-system",
    icon: <Icon fontSize="small">TicketAdd</Icon>,
    route: "/ticket-add",
    component: <TicketAdd />,
    protected: true,
    showInMenu: false,
    role: [3],
  },
  {
    type: "collapse",
    name: "Tickets Edit",
    key: "tickets-edit",
    icon: <Icon fontSize="small">TicketAdd</Icon>,
    route: "/tickets-edit/:id",
    component: <TicketEdit />,
    protected: true,
  },
  {
    type: "",
    name: "Mission Tracker1",
    key: "Mission-tracker1",
    route: "/mission-tracker/:id",
    component: <Report />,
    protected: true,
  },
  {
    type: "",
    name: "Mission Tracker1",
    key: "Mission-tracker1",
    route: "/mission-tracker/add/:id",
    component: <FillForm />,
    protected: true,
  },
  {
    type: "",
    name: "Mission Tracker Edit",
    key: "mission-tracker-edit",
    route: "/mission-tracker/edit/:id/:created_by/:submission_id",
    component: <EditForm />,
    protected: true,
  },
  {
    type: "",
    name: "Mission Tracker Results",
    key: "Mission-tracker-results",
    route: "/mission-tracker/results/:formId",
    component: <SubmissionResults />,
    protected: true,
  },
  {
    type: "",
    name: "Mission Tracker Details",
    key: "mission-tracker-details",
    route: "/mission/:id",
    component: <UserMission />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Post Lesson",
    key: "lessons-add",
    icon: <Icon fontSize="small">post_add</Icon>,
    route: "/lessons/add",
    component: <LessonsAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Edit Lesson",
    key: "lessons-edit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/lessons/edit/:lesson_id",
    component: <LessonsAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Lesson Details",
    key: "lessons-details",
    icon: <Icon fontSize="small">visibility</Icon>,
    route: "/lessons/details/:lesson_id",
    component: <LessonsDetails />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Add Event",
    key: "events-add",
    icon: <Icon fontSize="small">event_available</Icon>,
    route: "/events/add",
    component: <EventsAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Edit Event Submission",
    key: "events-edit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/events/edit/:submission_id/:user_id",
    component: <EventsAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2, 3],
  },
  {
    type: "collapse",
    name: "Add Publication",
    key: "publications-add",
    icon: <Icon fontSize="small">add_circle</Icon>,
    route: "/publications/add",
    component: <PublicationsAdd />,
    protected: true,
    showInMenu: false,
    role: [1],
  },
  {
    type: "collapse",
    name: "Edit Publication",
    key: "publications-edit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/publications/edit/:id",
    component: <PublicationsAdd />,
    protected: true,
    showInMenu: false,
    role: [1],
  },
  {
    type: "collapse",
    name: "Upload Work Plan",
    key: "work-plan-add",
    icon: <Icon fontSize="small">upload_file</Icon>,
    route: "/work-plan/add",
    component: <WorkPlanAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2],
  },
  {
    type: "collapse",
    name: "Edit Work Plan",
    key: "work-plan-edit",
    icon: <Icon fontSize="small">edit</Icon>,
    route: "/work-plan/edit/:id",
    component: <WorkPlanAdd />,
    protected: true,
    showInMenu: false,
    role: [1, 2],
  },

  {
    type: "collapse",
    name: "Log Out",
    key: "log-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/logout",
    component: <Logout />,
    protected: true,
    showInMenu: true,
    role: [1, 2, 3],
  },
];

export default routes;
